var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "hb-section",
      class: {
        "hb-section--bordered": _vm.bordered,
        "hb-section--flush": !_vm.padded,
      },
    },
    [
      _vm.title || _vm.$slots.actions || _vm.$slots.header
        ? _c("header", { staticClass: "hb-section__head" }, [
            _c(
              "div",
              { staticClass: "hb-section__heading" },
              [
                _vm.title
                  ? _c("h3", { staticClass: "hb-section__title" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ])
                  : _vm._e(),
                _vm.subtitle || _vm.$slots.subtitle
                  ? _c(
                      "div",
                      { staticClass: "hb-section__subtitle" },
                      [
                        _vm._t("subtitle", function () {
                          return [_vm._v(_vm._s(_vm.subtitle))]
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._t("header"),
              ],
              2
            ),
            _vm.$slots.actions
              ? _c(
                  "div",
                  { staticClass: "hb-section__actions" },
                  [_vm._t("actions")],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }